<!-- <div class="container">
  <div class="contact-page">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-3 sidebar">
        <app-side-menu></app-side-menu>
      </div> -->
      <h1 class="displaynone">Login</h1>
      <form class="form-white-full col-md-12" #loginForm="ngForm" (ngSubmit)="onSubmit()" *ngIf="IsLoginShow=='1' && logintype=='1'">
        
        <div class="col-md-12 contact-form">
          <div class="col-md-12">
            <label *ngIf="loginlable!=null && loginlable!=undefined && loginlable!=''">{{loginlable}}</label> 
            <!-- <span *ngIf="loginmsg!=null && loginmsg!=undefined && loginmsg!=''"> {{loginmsg}}</span> -->
              <div *ngIf="loginmsg!=null && loginmsg!=undefined && loginmsg!=''" [innerHTML]="loginmsg | safe: 'html'"></div>
          </div>


          <div class="col-md-12 contact-title">
            <h3>Login</h3>
          </div>

          <div class="col-md-12">
            <label class="text-danger">All fields marked with an asterisk (*) must be completed</label>
          </div>

          <div class="col-md-6">
            <div class="col-md-12" *ngIf="IsMultiCompanySetting=='1'">
              <div class="form-group">
                <label class="info-title">Select Company
                </label><span>*</span>
                <select class="form-control unicase-form-control text-input" [(ngModel)]='company' #shipTo="ngModel"
                  (change)="companychange($event.target.value)" required name="shipTo">
                  <option value="0">Select Company</option>
                  <option *ngFor="let sycp of AllCompaniesList" [value]="sycp.company_sy">{{sycp.name}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="info-title">{{label1}}
                </label><span>*</span>
                <input type="text" class="form-control unicase-form-control text-input" #CustomerId="ngModel"
                 id="userCustomerId" [(ngModel)]="user.CustomerId" name="CustomerId" [ngModelOptions]="{standalone:true}">
              </div>
            </div>
            <div class="col-md-12 " *ngIf="(webtype=='5' || webtype=='6') && ismulti=='1'">
              <div class="form-group">
                <label class="info-title">{{label2}}
                </label>
                <input type="text" class="form-control unicase-form-control text-input" #Username="ngModel"
                  [(ngModel)]="user.Username" name="Username" [ngModelOptions]="{standalone:true}">
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="info-title">Password</label><span>* (CASE SENSITIVE)</span>
                <table  id="passwordtable">
                  <tr>
                    <td>
                      
                <input [type]="hide ? 'password' : 'text'" class="form-control unicase-form-control text-input" #Password="ngModel"
                 id="userPassword" [(ngModel)]="user.Password" name="Password" [ngModelOptions]="{standalone:true}">
                </td>
                <td>
                  <!-- <div class="eye_icon"> -->
                    <i class="fa fa-eye"  (click)="hide = !hide" *ngIf="!hide"  aria-hidden="true"></i>
                    <i class="fa fa-eye-slash"  (click)="hide = !hide" *ngIf="hide" aria-hidden="true"></i>
                  <!-- </div> -->
                </td>
                </tr>
                </table>
                 <!-- <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon> -->
              </div>
            </div>
            <div class="col-md-12" *ngIf="isError==true">
              <div class="form-group">
                <label class="text-danger"> {{Errormsg}}</label>
              </div>
            </div>
            <div class="col-md-12" *ngIf="iscaptcha=='1'">
              <div class="form-group">
                <re-captcha name="resolved" (resolved)="resolved($event)" required
                  siteKey="6Lc2-l4UAAAAAN8mmuWceB_l8vYl7_dC3mpg36bX"></re-captcha>
                <!--live -->
                <!-- <re-captcha name="resolved" (resolved)="resolved($event)" required siteKey="6LfA-14UAAAAAPAhAS0ULME3IatKB0Y9jwFvTK2u"></re-captcha> -->
                <!-- //localhost -->
              </div>
            </div>
            <div class="col-md-12" id="ForgotPassword3">
              <div class="form-group">
                <a class="cpointer" (click)="Gotologin()">Forgot Password?</a>
              </div>
            </div>
            <div class="col-md-12 outer-bottom-small m-t-20 logn_butn">
              <button type="submit" class="btn-upper btn btn-primary checkout-page-button fix_btnSM">Login</button>
              <button type="button" *ngIf="isShowRegistration" (click)="register()" class="btn-upper btn btn-primary checkout-page-button fix_btnSM">Register</button>
              <button type="button" *ngIf="isfindmyid=='1'" (click)="findmyidshow()" class="btn-upper btn btn-primary checkout-page-button fix_btnLg">Find My Customer ID</button>
              <!-- <button *ngIf="webtype!='1' && isGuestLogin" type="button" (click)="Onguestlogin()"
                class="btn-upper btn btn-primary checkout-page-button">Login as Guest</button> -->
            </div>
                  
          </div>
          
        </div>
      </form>
      <form class="form-white-full col-md-12" #loginForm="ngForm" (ngSubmit)="onSubmitnew()" *ngIf="IsLoginShow=='1' && logintype=='2'">
        <div class="col-md-12 contact-form">
          <div class="col-md-12">
            
            <label *ngIf="loginlable!=null && loginlable!=undefined && loginlable!=''">{{loginlable}}</label> 
            <!-- <span *ngIf="loginmsg!=null && loginmsg!=undefined && loginmsg!=''"> {{loginmsg}}</span> -->
              <div *ngIf="loginmsg!=null && loginmsg!=undefined && loginmsg!=''" [innerHTML]="loginmsg | safe: 'html'"></div>
          </div>


          <div class="col-md-12 contact-title">
            <h3>Login</h3>
          </div>

          <div class="col-md-12">
            <label class="text-danger">All fields marked with an asterisk (*) must be completed</label>
          </div>

          <div class="col-md-6">
            <div class="col-md-12" *ngIf="IsMultiCompanySetting=='1'">
              <div class="form-group">
                <label class="info-title">Select Company
                </label><span>*</span>
                <select class="form-control unicase-form-control text-input" [(ngModel)]='company' #shipTo="ngModel"
                  (change)="companychange($event.target.value)" required name="shipTo"  [ngModelOptions]="{standalone:true}">
                  <option value="0">Select Company</option>
                  <option *ngFor="let sycp of AllCompaniesList" [value]="sycp.company_sy">{{sycp.name}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="info-title">{{label1}}
                </label><span>*</span>
                <input type="text" class="form-control unicase-form-control text-input" #CustomerId="ngModel"
                 id="userCustomerId" [(ngModel)]="user.CustomerId" name="CustomerId" [ngModelOptions]="{standalone:true}">
              </div>
            </div>
            
            <div class="col-md-12">
              <div class="form-group">
                <label class="info-title">Password</label><span>* (CASE SENSITIVE)</span>
                <table  id="passwordtable">
                  <tr>
                    <td>
                      
                <input [type]="hide ? 'password' : 'text'" class="form-control unicase-form-control text-input" #Password="ngModel"
                 id="userPassword" [(ngModel)]="user.Password" name="Password" [ngModelOptions]="{standalone:true}">
                </td>
                <td>
                  <!-- <div class="eye_icon"> -->
                    <i class="fa fa-eye"  (click)="hide = !hide" *ngIf="!hide"  aria-hidden="true"></i>
                    <i class="fa fa-eye-slash"  (click)="hide = !hide" *ngIf="hide" aria-hidden="true"></i>
                  <!-- </div> -->
                </td>
                </tr>
                </table>
                 <!-- <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon> -->
              </div>
            </div>
            <div class="col-md-12" *ngIf="isError==true">
              <div class="form-group">
                <label class="text-danger"> {{Errormsg}}</label>
              </div>
            </div>
            <div class="col-md-12" *ngIf="iscaptcha=='1'">
              <div class="form-group">
                <re-captcha name="resolved" (resolved)="resolved($event)" required
                  siteKey="6Lc2-l4UAAAAAN8mmuWceB_l8vYl7_dC3mpg36bX"></re-captcha>
                <!--live -->
                <!-- <re-captcha name="resolved" (resolved)="resolved($event)" required siteKey="6LfA-14UAAAAAPAhAS0ULME3IatKB0Y9jwFvTK2u"></re-captcha> -->
                <!-- //localhost -->
              </div>
            </div>
            <div class="col-md-12" id="ForgotPassword1">
              <div class="form-group">
                <a class="cpointer" (click)="Gotologin()">Forgot Password?</a>
              </div>
            </div>
            <div class="col-md-12 outer-bottom-small m-t-20">
              <button type="submit" class="btn-upper btn btn-primary checkout-page-button">Login</button>
              <button type="button" *ngIf="isShowRegistration" (click)="register()" class="btn-upper btn btn-primary checkout-page-button">Register</button>
              <button type="button" *ngIf="isfindmyid=='1'" (click)="findmyidshow()" class="btn-upper btn btn-primary checkout-page-button">Find My Customer ID</button>
              <!-- <button *ngIf="webtype!='1' && isGuestLogin" type="button" (click)="Onguestlogin()"
                class="btn-upper btn btn-primary checkout-page-button">Login as Guest</button> -->
            </div>
                  
          </div>
          
        </div>
      </form>
      <form class="form-white-full col-md-12" #findid="ngForm" (ngSubmit)="findmyid()" *ngIf="IsLoginShow=='3'">
        <div class="col-md-12 contact-form">
          <div class="col-md-12">
            <div class="col-md-12 contact-title">
              <h3>Find My Customer ID</h3>
            </div>      
            <div class="form-group">
              <label class="info-title">Email </label><span>*</span>
              <input type="text" class="form-control unicase-form-control text-input" placeholder="Enter your email"
                [(ngModel)]="EmailAddress" name="EmailAddress" [ngModelOptions]="{standalone:true}">
            </div>
            <div class="col-md-12 outer-bottom-small m-t-20">
              <button type="submit" *ngIf="isfindmyid=='1'" class="btn-upper btn btn-primary checkout-page-button">Search</button>
              <button type="button" (click)="Gotologinnew()" class="btn-upper btn btn-primary checkout-page-button">Go
                To Login</button>

            </div>
            <label class="info-title">{{emailmsg}}</label>
          </div>
          </div>
      </form>
      <form class="form-white-full col-md-12" #loginForm="ngForm" (ngSubmit)="onSubmitship()" *ngIf="IsLoginShow=='1' && logintype=='3'">
        
        <div class="col-md-12 contact-form">
          <div class="col-md-12">
            <label *ngIf="loginlable!=null && loginlable!=undefined && loginlable!=''">{{loginlable}}</label> 
            <!-- <span *ngIf="loginmsg!=null && loginmsg!=undefined && loginmsg!=''"> {{loginmsg}}</span> -->
              <div *ngIf="loginmsg!=null && loginmsg!=undefined && loginmsg!=''" [innerHTML]="loginmsg | safe: 'html'"></div>
          </div>


          <div class="col-md-12 contact-title">
            <h3>Login</h3>
          </div>

          <div class="col-md-12">
            <label class="text-danger">All fields marked with an asterisk (*) must be completed</label>
          </div>

          <div class="col-md-6">
            
            <div class="col-md-12">
              <div class="form-group">
                <label class="info-title">{{label1}}
                </label><span>*</span>
                <input type="text" class="form-control unicase-form-control text-input" #CustomerId="ngModel"
                 id="userCustomerId" [(ngModel)]="user.CustomerId" name="CustomerId" [ngModelOptions]="{standalone:true}">
              </div>
            </div>
            
            <div class="col-md-12">
              <div class="form-group">
                <label class="info-title">Password</label><span>* (CASE SENSITIVE)</span>
                <table  id="passwordtable">
                  <tr>
                    <td>
                      
                <input [type]="hide ? 'password' : 'text'" class="form-control unicase-form-control text-input" #Password="ngModel"
                 id="userPassword" [(ngModel)]="user.Password" name="Password" [ngModelOptions]="{standalone:true}">
                </td>
                <td>
                  <!-- <div class="eye_icon"> -->
                    <i class="fa fa-eye"  (click)="hide = !hide" *ngIf="!hide"  aria-hidden="true"></i>
                    <i class="fa fa-eye-slash"  (click)="hide = !hide" *ngIf="hide" aria-hidden="true"></i>
                  <!-- </div> -->
                </td>
                </tr>
                </table>
                 <!-- <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon> -->
              </div>
            </div>
            <div class="col-md-12" *ngIf="isError==true">
              <div class="form-group">
                <label class="text-danger"> {{Errormsg}}</label>
              </div>
            </div>
            <div class="col-md-12" *ngIf="iscaptcha=='1'">
              <div class="form-group">
                <re-captcha name="resolved" (resolved)="resolved($event)" required
                  siteKey="6Lc2-l4UAAAAAN8mmuWceB_l8vYl7_dC3mpg36bX"></re-captcha>
                <!--live -->
                <!-- <re-captcha name="resolved" (resolved)="resolved($event)" required siteKey="6LfA-14UAAAAAPAhAS0ULME3IatKB0Y9jwFvTK2u"></re-captcha> -->
                <!-- //localhost -->
              </div>
            </div>
            <div class="col-md-12" id="ForgotPassword2">
              <div class="form-group">
                <a class="cpointer" (click)="Gotologin()">Forgot Password?</a>
              </div>
            </div>
            <div class="col-md-12 outer-bottom-small m-t-20 logn_butn">
              <button type="submit" class="btn-upper btn btn-primary checkout-page-button fix_btnSM">Login</button>
              <!-- <button type="button" *ngIf="isShowRegistration" (click)="register()" class="btn-upper btn btn-primary checkout-page-button fix_btnSM">Register</button> -->
              <!-- <button type="button" *ngIf="isfindmyid=='1'" (click)="findmyidshow()" class="btn-upper btn btn-primary checkout-page-button fix_btnLg">Find My Customer ID</button> -->
              <!-- <button *ngIf="webtype!='1' && isGuestLogin" type="button" (click)="Onguestlogin()"
                class="btn-upper btn btn-primary checkout-page-button">Login as Guest</button> -->
            </div>
                  
          </div>
          
        </div>
      </form>
     <!-- <div class="col-md-9 contact-form" style="min-height: 600px;" *ngIf="IsLoginShow=='3'">
        <div class="row">
          <h3 style="padding: 10px;">Find My Customer ID</h3>
           <table style="width: 100%;padding: 10px;" *ngIf="showemailid=='1'">
            <tr>
              <td style="width: 20%;">Email :</td>
              <td style="width: 80%;"><input type="text" class="form-control unicase-form-control text-input" placeholder="Enter your email"
                [(ngModel)]="EmailAddress" name="EmailAddress"></td>
                

            </tr>
            <tr> <td style="display: flex;"><button type="button" *ngIf="isfindmyid=='1'" (click)="findmyid()" class="btn-upper btn btn-primary checkout-page-button">Search</button>
              <button type="button" (click)="Gotologinnew()" class="btn-upper btn btn-primary checkout-page-button">Go
                To Login</button></td> </tr>
            <tr>
              <td colspan="3"><label class="info-title">{{emailmsg}}</label></td>
            </tr>
          </table>               -->
          <!-- <div class="col-sm-12">
            <label class="info-title" style="margin-bottom: 15px;">Email :</label>
            <input type="text" class="form-control unicase-form-control text-input" style="margin-bottom: 15px;"placeholder="Enter your email"
                [(ngModel)]="EmailAddress" name="EmailAddress">
                <button type="button" *ngIf="isfindmyid=='1'" (click)="findmyid()" style="margin-bottom: 15px;" class="btn-upper btn btn-primary checkout-page-button">Search</button>
                  <button style="margin-bottom: 15px;" type="button" (click)="Gotologinnew()" class="btn-upper btn btn-primary checkout-page-button">Go
                    To Login</button>
          </div> -->
          <!-- </div>
          </div> -->
      
      
      <div class="form-white-full col-md-12" *ngIf="IsLoginShow=='2'">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12 contact-title">
                <h4>Forgot Password</h4>
              </div>
              <div class="col-md-12">
                <label class="text-danger">All fields marked with an asterisk (*) must be completed</label>
              </div>
              
              <div *ngIf="isError" class="red-text center error-message">
                <i class="material-icons">error</i> {{Errormsg}}
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label class="info-title">{{lableforcustomerinforgotpassword}}
                  </label><span>*</span>
                  <input type="text" class="form-control unicase-form-control text-input" id="CustomerId" [(ngModel)]="CustomerID"
                    name="CustomerID" [ngModelOptions]="{standalone:true}">
                </div>
                <div class="form-group" *ngIf="logintype!=3">
                  <label class="info-title"
                    *ngIf="(webtype=='5' || webtype=='6') && ismulti=='1'">{{lableforcuUserinforgotpassword}}
                  </label>
                  <input type="text" *ngIf="(webtype=='5' || webtype=='6') && ismulti=='1'"
                    class="form-control unicase-form-control text-input" [(ngModel)]="UserID" name="UserID">
                </div>
                <div class="col-md-12" *ngIf="iscaptcha=='1'">
                  <div class="form-group">
                    <re-captcha name="resolved" (resolved)="resolved($event)" required
                      siteKey="6Lc2-l4UAAAAAN8mmuWceB_l8vYl7_dC3mpg36bX"></re-captcha>
                    <!--live -->
                    <!-- <re-captcha name="resolved" (resolved)="resolved($event)" required siteKey="6LfA-14UAAAAAPAhAS0ULME3IatKB0Y9jwFvTK2u"></re-captcha> -->
                    <!-- //localhost -->
                  </div>
                </div>
                <div class="form-group btnmd">
                  <button type="button" (click)="MailPassword()"
                    class="btn-upper marginBottom10 btn btn-primary checkout-page-button">Send Password to Email</button>
                  <button type="button" (click)="Gotologin()" class="btn-upper btn btn-primary checkout-page-button">Go
                    To Login</button>
                </div>
              </div>
            </div>
            <div *ngIf="forgotpwdmsg!=null && forgotpwdmsg!=undefined && forgotpwdmsg!=''" [innerHTML]="forgotpwdmsg | safe: 'html'"></div>  
          </div>
        </div>


      </div>




    <!-- </div>

  </div>
</div> -->